import {
    useMemo,
    useState,
} from 'react'

type Props<T> = {
    data: T[]
    rowsPerPage: number
}

type UsePaginatedDataReturn<T> = {
    currentPageData: T[]
    totalPages: number
    currentPage: number
    setCurrentPage: (page: number) => void
    totalRecords: number
}

const usePaginatedData = <T>({
    data,
    rowsPerPage,
}: Readonly<Props<T>>): UsePaginatedDataReturn<T> => {
    const [
        currentPage,
        setCurrentPage,
    ] = useState(1)

    const paginatedData = useMemo(() => {
        const totalRecords = data.length
        const totalPages = Math.ceil(totalRecords / rowsPerPage)

        const startIndex = (currentPage - 1) * rowsPerPage
        const endIndex = startIndex + rowsPerPage

        const currentPageData = data.slice(startIndex, endIndex)

        return {
            currentPageData,
            totalPages,
            totalRecords,
        }
    }, [
        data,
        rowsPerPage,
        currentPage,
    ])

    return {
        ...paginatedData,
        currentPage,
        setCurrentPage,
    }
}

export default usePaginatedData
